<div class="container">
  <nav class="account-details-nav" *autoScrollNavbar="'account-details-nav'">
    <!--Account-->
    <a
      class="nav-item"
      [routerLink]="['/account']"
      [routerLinkActive]="'active'"
      [class.active]="isActive('/account')"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'account.nav.account.screenreader' | translate: { fgbdefault: 'Move to Account page' } }}"
    >
      <label>{{ 'account.nav.profile' | translate }}</label>
    </a>

    <ng-container *notInPopulation="[populations.Pts, populations.Suite]">
      <a
        class="nav-item"
        [routerLink]="['/activity']"
        [routerLinkActive]="'active'"
        [class.active]="isActive('/activity')"
        [routerLinkActiveOptions]="{ exact: true }"
        attr.aria-label="{{
          'account.nav.activity.screenreader' | translate: { fgbdefault: 'Move to Transaction History page' }
        }}"
      >
        <label>{{ 'account.nav.activity' | translate }}</label>
      </a>
    </ng-container>

    <ng-container *ifScreenSize="screenType.Mobile">
      <ng-container *inPopulation="[populations.Suite]">
        <a
          class="nav-item"
          [routerLink]="['/activity']"
          [routerLinkActive]="'active'"
          [class.active]="isActive('/activity')"
          [routerLinkActiveOptions]="{ exact: true }"
          attr.aria-label="{{
            'account.nav.activity.screenreader' | translate: { fgbdefault: 'Move to Transaction History page' }
          }}"
        >
          <label>{{ 'account.nav.activity' | translate }}</label>
        </a>
      </ng-container>
    </ng-container>

    <!--Partners-->
    <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.partners'">
      <a
        class="nav-item"
        [routerLink]="['/partners']"
        [routerLinkActive]="'active'"
        [class.active]="isActive('/partners')"
        [routerLinkActiveOptions]="{ exact: true }"
        attr.aria-label="{{ 'account.nav.partners.screenreader' | translate: { fgbdefault: 'Move to partners page' } }}"
      >
        <label>{{ 'account.nav.partners' | translate }}</label>
      </a></ng-container
    >

    <!--Transfer eCash-->
    <ng-container *notInPopulation="[populations.Suite, populations.Free]"
      ><a
        class="nav-item"
        [routerLink]="['/ecash-transfer']"
        [routerLinkActive]="'active'"
        [class.active]="isActive('/ecash-transfer')"
        [routerLinkActiveOptions]="{ exact: true }"
        attr.aria-label="{{
          'account.nav.ecash.transfer.screenreader' | translate: { fgbdefault: 'Move to transfer ecash page' }
        }}"
      >
        <label>{{ 'account.nav.ecash.transfer' | translate }}</label>
      </a></ng-container
    >

    <!--Refer a friend-->
    <a
      class="nav-item"
      [routerLink]="['/referAFriend']"
      [routerLinkActive]="'active'"
      [class.active]="isActive('/referAFriend')"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'account.nav.refer.a.friend.screenreader' | translate: { fgbdefault: 'Move to refer a friend page' } }}"
    >
      <label>{{ 'account.nav.refer.a.friend' | translate }}</label>
    </a>
  </nav>
</div>
